{
  "de": {
    "wysiwyg": {
      "actions": {
        "alignCenter": "Zentriert ausrichten",
        "alignLeft": "Links ausrichten",
        "alignRight": "Rechts ausrichten",
        "blockType": "Absatztyp",
        "blockquote": "Zitat",
        "bold": "Fett",
        "bulletList": "Ungeordnete Liste",
        "code": "Code",
        "codeBlock": "Code Block",
        "fontFamily": "Schriftfamilie",
        "fontSize": "Schriftgröße",
        "h1": "Überschrift 1",
        "h2": "Überschrift 2",
        "h3": "Überschrift 3",
        "highlight": "Hervorheben",
        "horizontalRule": "Trennlinie",
        "iframe": "Einbetten von iFrame",
        "images": "Bilder einfügen",
        "italic": "Kursiv",
        "katex": "LaTeX Formel",
        "katexBlock": "LaTeX Formelblock",
        "link": "Link",
        "more": "Einfügeoptionen",
        "orderedList": "Geordnete Liste",
        "redo": "Wiederherstellen",
        "specialCharacters": "Sonderzeichen",
        "strikethrough": "Durchgestrichen",
        "table": "Tabelle",
        "textColor": "Textfarbe",
        "underline": "Unterstrichen",
        "undo": "Rückgängig"
      },
      "blockTypes": {
        "five": "Überschrift 5",
        "four": "Überschrift 4",
        "one": "Überschrift 1",
        "paragraph": "Absatz",
        "six": "Überschrift 6",
        "three": "Überschrift 3",
        "two": "Überschrift 2"
      },
      "colors": {
        "default": "Standard",
        "gray": "Grau",
        "indigo": "Indigo",
        "magenta": "Magenta",
        "orange": "Orange",
        "petrol": "Petrol",
        "purple": "Lila",
        "red": "Rot",
        "teal": "Türkis"
      },
      "dialogs": {
        "deleteTable": {
          "text": "Die Tabelle wird mit allen enthaltenen Inhalten entfernt.",
          "title": "Tabelle löschen?"
        },
        "iframe": {
          "text": "Gib die URL der Seite ein, die als iFrame in den Text eingebettet wird.",
          "title": "iFrame einbetten"
        },
        "link": {
          "text": "Gib die URL ein, auf die der markierte Text verlinken soll.",
          "title": "Link einfügen"
        },
        "urlPrompt": {
          "label": "URL",
          "placeholder": "Beispiel: https://example.com"
        }
      },
      "errors": {
        "imageFormatUnsupported": "Dieses Bildformat kann im Text nicht angezeigt werden.",
        "imageInsertFailed": "Das Bild konnte nicht eingefügt werden."
      },
      "specialCharactersModal": {
        "categories": {
          "Arrows": "Pfeile",
          "Basic Latin": "Basis-Latein",
          "Currency Symbols": "Währungssymbole",
          "Dingbats": "Dingbats",
          "Enclosed Alphanumerics": "Eingeklammerte alphanumerische Zeichen",
          "General Punctuation": "Allgemeine Interpunktion",
          "Geometric Shapes": "Geometrische Formen",
          "Greek and Coptic": "Griechisch und Koptisch",
          "Latin Extended-A": "Latein Erweitert-A",
          "Latin Extended-B": "Latein Erweitert-B",
          "Latin-1 Supplement": "Latein-1 Ergänzung",
          "Mathematical Operators": "Mathematische Operatoren",
          "Miscellaneous Symbols": "Verschiedene Symbole",
          "Miscellaneous Technical": "Verschiedene technische Zeichen",
          "Superscripts and Subscripts": "Hoch- und Tiefstellungen"
        },
        "header": "Sonderzeichen"
      }
    }
  }
}
